import { render, staticRenderFns } from "./index.vue?vue&type=template&id=048bd6cf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=048bd6cf&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048bd6cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048bd6cf')) {
      api.createRecord('048bd6cf', component.options)
    } else {
      api.reload('048bd6cf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=048bd6cf&scoped=true", function () {
      api.rerender('048bd6cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SideHelper/Mobile/Serve/index.vue"
export default component.exports